import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { SeoState } from '@store/seo/seo.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([SeoState])],
})
export class SeoStoreModule {}
